<template>
  <Form :label-width="150" label-position="right" ref="busiCtl" :model="busiCtl" :rules="ruleValidate">
    <Card>
      <FormItem label="平台:" required>
        <Select style="width:200px;" v-model="busiCtl.platformCode" @on-change="queryCouponBusiCtl">
          <Option v-for="(item, i) in CouponPlatform" :key="i" :value="item.code">{{item.name}}</Option>
        </Select>
      </FormItem>
      <Divider>规则设置</Divider>
      <FormItem label="订单最高优惠规则:" required>
        <RadioGroup v-model="orderMaxCouponAmountOn">
          <Radio :label="1" border>
            <span>启用</span>
          </Radio>
          <Radio :label="2" border>
            <span>关闭</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <Row v-show="orderMaxCouponAmountOn===1">
        <Row>
          <Col span="24">
            <FormItem prop="orderMaxCouponAmountRatio">
              <Radio v-model="orderMaxCouponAmountType1"
                     @on-change="changeOrderMaxCouponAmountType1"></Radio>
              <span>总优惠比例:</span>
              <label>
                <Input
                  placeholder="订单最高优惠比例（0-100）"
                  style="width: 100px;"
                  v-model="busiCtl.orderMaxCouponAmountRatio"
                ></Input>
              </label>
              <span style="padding-left: 10px;">%</span>
            </FormItem>
            <FormItem style="margin-left: 30px;">
              <label>钱包比例:
                <Input placeholder="钱包支付所占比例"
                       style="width:120px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountRatioWallet"
                ></Input>
              </label>
              <label>返利比例:
                <Input placeholder="返利支付所占比例"
                       style="width:120px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountRatioRebate"
                ></Input>
              </label>
              <label>优惠券比例:
                <Input placeholder="优惠券支付所占比例"
                       style="width:140px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountRatioCoupon"
                ></Input>
              </label>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem prop="orderMaxCouponAmountMoney">
              <Radio v-model="orderMaxCouponAmountType2"
                     @on-change="changeOrderMaxCouponAmountType2"></Radio>
              <span>总优惠金额:</span>
              <label>
                <Input
                  placeholder="订单最高优惠金额"
                  style="width: 100px;"
                  v-model="busiCtl.orderMaxCouponAmountMoney"
                ></Input>
              </label>
            </FormItem>
            <FormItem style="margin-left: 30px;">
              <label>钱包金额:
                <Input placeholder="钱包支付所占金额"
                       style="width:120px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountMoneyWallet"
                ></Input>
              </label>
              <label>返利金额:
                <Input placeholder="返利支付所占金额"
                       style="width:120px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountMoneyRebate"
                ></Input>
              </label>
              <label>优惠券金额:
                <Input placeholder="优惠券支付所占金额"
                       style="width:140px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountMoneyCoupon"
                ></Input>
              </label>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem>
              <Radio v-model="orderMaxCouponAmountType3"
                     @on-change="changeOrderMaxCouponAmountType3"></Radio>
              <span>订单总金额:</span>
            </FormItem>
            <FormItem style="margin-left: 30px;">
              <label>钱包金额上限:
                <Input placeholder="钱包支付金额上限"
                       style="width:120px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountOrderMoneyWallet"
                ></Input>
              </label>
              <label>返利金额上限:
                <Input placeholder="返利支付金额上限"
                       style="width:120px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountOrderMoneyRebate"
                ></Input>
              </label>
              <label>优惠券金额上限:
                <Input placeholder="优惠券支付金额上限"
                       style="width:140px;margin-right: 10px;"
                       v-model="busiCtl.orderMaxCouponAmountOrderMoneyCoupon"
                ></Input>
              </label>
            </FormItem>
          </Col>
        </Row>
      </Row>
      <FormItem>
        <Button type="primary" @click="saveCouponBusiCtl">保存</Button>
      </FormItem>
    </Card>
    <Divider></Divider>
  </Form>
</template>

<script>
  const validateOrderMaxCouponAmountRatio = (rule, value, callback) => {
    if (isNaN(value)) {
      callback(new Error('比例请输入数字'));
    } else if (value === '') {
      callback(new Error('请输入比例'));
    } else {
      if (value < 0 || value > 100) {
        callback(new Error('比例必须在0-100之间'));
      }
      callback();
    }
  };
  const validateOrderMaxCouponAmountMoney = (rule, value, callback) => {
    if (isNaN(value)) {
      callback(new Error('金额请输入数字'));
    } else if (value === '') {
      callback(new Error('请输入金额'));
    } else {
      if (value < 0) {
        callback(new Error('金额必须大于0'));
      }
      callback();
    }
  };
  export default {
    name: "busictl",
    data() {
      return {
        CouponPlatform: [],
        orderMaxCouponAmountOn: 1,
        orderMaxCouponAmountType1: true,
        orderMaxCouponAmountType2: false,
        orderMaxCouponAmountType3: false,
        busiCtl: {
          platformCode: '',
          orderMaxCouponAmountCheck: true,
          orderMaxCouponAmountType: 1,
          orderMaxCouponAmountRatio: 50,
          orderMaxCouponAmountRatioWallet: 0,
          orderMaxCouponAmountRatioRebate: 0,
          orderMaxCouponAmountRatioCoupon: 0,

          orderMaxCouponAmountMoney: 0,
          orderMaxCouponAmountMoneyWallet: 0,
          orderMaxCouponAmountMoneyRebate: 0,
          orderMaxCouponAmountMoneyCoupon: 0,

          orderMaxCouponAmountOrderMoneyWallet: 0,
          orderMaxCouponAmountOrderMoneyRebate: 0,
          orderMaxCouponAmountOrderMoneyCoupon: 0,
        },
        ruleValidate: {
          orderMaxCouponAmountRatio: [
            {validator: validateOrderMaxCouponAmountRatio, trigger: 'blur'}
          ],
          orderMaxCouponAmountMoney: [
            {validator: validateOrderMaxCouponAmountMoney, trigger: 'blur'}
          ]
        },
      }
    },
    methods: {
      changeOrderMaxCouponAmountType1() {
        this.orderMaxCouponAmountType1 = true;
        this.orderMaxCouponAmountType2 = false;
        this.orderMaxCouponAmountType3 = false;
        this.busiCtl.orderMaxCouponAmountType = 1;
      },
      changeOrderMaxCouponAmountType2() {
        this.orderMaxCouponAmountType1 = false;
        this.orderMaxCouponAmountType2 = true;
        this.orderMaxCouponAmountType3 = false;
        this.busiCtl.orderMaxCouponAmountType = 2;
      },
      changeOrderMaxCouponAmountType3() {
        this.orderMaxCouponAmountType1 = false;
        this.orderMaxCouponAmountType2 = false;
        this.orderMaxCouponAmountType3 = true;
        this.busiCtl.orderMaxCouponAmountType = 3;
      },
      queryBusiPlatform() {
        let http = 'couponqueryBusiPlatform';
        this.$api[http]({}).then((res) => {
          if (res.code === '200') {
            this.CouponPlatform = res.data.CouponPlatform;
          } else {
            this.$Message.error('查询优惠券业务平台枚举失败.');
          }
        });
      },
      saveCouponBusiCtl() {
        if (this.busiCtl.platformCode === '' || this.busiCtl.platformCode === undefined) {
          this.$Message.error('请先选择平台');
          return;
        }
        if (this.orderMaxCouponAmountOn !== 1) {
          this.busiCtl.orderMaxCouponAmountRatio = 0;
          this.busiCtl.orderMaxCouponAmountMoney = 0;
        }
        this.$refs['busiCtl'].validate((valid) => {
          if (valid) {
            this.$api['saveCouponBusiCtl'](this.busiCtl).then((res) => {
              if (res.code === '200') {
                this.$Message.success('设置优惠券规则成功');
              } else {
                this.$Message.error('设置优惠券规则失败.');
              }
            });
          } else {
            this.$Message.error('数据校验失败,请检查输入的数据.');
          }
        })
      },
      queryCouponBusiCtl() {
        if (this.busiCtl.platformCode === '' || this.busiCtl.platformCode === undefined) {
          this.$Message.error('请先选择平台');
          return;
        }
        this.$api['queryCouponBusiCtl'](this.busiCtl).then((res) => {
          if (res.code === '200') {
            this.$Message.success('查询优惠券规则成功');
            let d = res.data;
            this.busiCtl.orderMaxCouponAmountCheck = d.orderMaxCouponAmountCheck;
            this.busiCtl.orderMaxCouponAmountType = d.orderMaxCouponAmountType;
            this.busiCtl.orderMaxCouponAmountRatio = d.orderMaxCouponAmountRatio * 100;
            this.busiCtl.orderMaxCouponAmountRatioWallet = d.orderMaxCouponAmountRatioWallet * 100;
            this.busiCtl.orderMaxCouponAmountRatioRebate = d.orderMaxCouponAmountRatioRebate * 100;
            this.busiCtl.orderMaxCouponAmountRatioCoupon = d.orderMaxCouponAmountRatioCoupon * 100;

            this.busiCtl.orderMaxCouponAmountMoney = d.orderMaxCouponAmountMoney;
            this.busiCtl.orderMaxCouponAmountMoneyWallet = d.orderMaxCouponAmountMoneyWallet;
            this.busiCtl.orderMaxCouponAmountMoneyRebate = d.orderMaxCouponAmountMoneyRebate;
            this.busiCtl.orderMaxCouponAmountMoneyCoupon = d.orderMaxCouponAmountMoneyCoupon;

            this.busiCtl.orderMaxCouponAmountOrderMoneyWallet = d.orderMaxCouponAmountOrderMoneyWallet;
            this.busiCtl.orderMaxCouponAmountOrderMoneyRebate = d.orderMaxCouponAmountOrderMoneyRebate;
            this.busiCtl.orderMaxCouponAmountOrderMoneyCoupon = d.orderMaxCouponAmountOrderMoneyCoupon;

            if (this.busiCtl.orderMaxCouponAmountCheck === true) {
              this.orderMaxCouponAmountOn = 1;
            } else {
              this.orderMaxCouponAmountOn = 2;
            }

            if (this.busiCtl.orderMaxCouponAmountType === 1) {
              this.orderMaxCouponAmountType1 = true;
              this.orderMaxCouponAmountType2 = false;
              this.orderMaxCouponAmountType3 = false;
            }
            if (this.busiCtl.orderMaxCouponAmountType === 2) {
              this.orderMaxCouponAmountType1 = false;
              this.orderMaxCouponAmountType2 = true;
              this.orderMaxCouponAmountType3 = false;
            }
            if (this.busiCtl.orderMaxCouponAmountType === 3) {
              this.orderMaxCouponAmountType1 = false;
              this.orderMaxCouponAmountType2 = false;
              this.orderMaxCouponAmountType3 = true;
            }
          } else {
            this.$Message.error('查询优惠券规则失败.');
          }
        });
      },
    },
    created() {
      this.queryBusiPlatform();
    },
    watch: {
      orderMaxCouponAmountOn(n, o) {
        this.busiCtl.orderMaxCouponAmountCheck = n === 1;
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/rulectl/busictl.vue